import { ReactElement } from 'react';
import { useDeviceType } from '@client/common/hooks';
import { DataTable as DataTableComponent } from 'b2b-components/theme/components/DataTable';
import { Props } from './';

export const DataTable = (props: Props): ReactElement => {
  const deviceType = useDeviceType();

  return (
    <DataTableComponent
      {...props}
      deviceType={deviceType}
    />
  );
};
